import _ from 'lodash'

const formatAliases = {
  "12`": "12\"",
  "cd": "CD",
  "digital ep": "Digital EP",
  "dvd": "DVD",
  "ep": "EP",
  "lp": "LP"
};

const capitalizeWords = (str) => {
  return _.map(str.split(' '), word => 
    word.charAt(0).toUpperCase() + word.slice(1)
  ).join(' ');
}

export const physicalFormatsFormatter = {
	formatPhysicalFormats
};

function formatPhysicalFormats(physicalFormats) {  
  return _.groupBy(
    _.orderBy(_.map(physicalFormats, f=>{
      if(f.secondary_value)
        return {
          label: f.secondary_label,
          value: `${f.primary_value}~${f.secondary_value}`,
          primary_label: formatAliases.hasOwnProperty(f.primary_label) ? formatAliases[f.primary_label] : capitalizeWords(f.primary_label),
          primary_label_raw: f.primary_label,
        }
      else 
        return {
          label: formatAliases.hasOwnProperty(f.primary_label) ? formatAliases[f.primary_label] : capitalizeWords(f.primary_label),
          value: `${f.primary_value}~`,
          primary_label: 'unknown',
          primary_label_raw: f.primary_label
        }
    
    }), ['primary_label_raw', 'label'], ['asc', 'asc']),
    'primary_label'
  );
}
